module.exports = __webpack_public_path__ + "static/media/login_school_background.f3306335.png";